<!--
  WARNING!

  this file was automatically generated and should be updated using:

  ng g lazy-component extensions/copilot/shared/copilot/copilot.component.ts
-->
<ng-template #anchor />
